import { AppHelper } from "../appHelper"
import { AppBaseProps, CommonApp, Context, Entity } from "../core/components/commonApp";
import { Helper } from "../core/util/helper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { Sheet, SheetEventType } from "../../siteManagement/sheet";
import { General } from "../../siteManagement/general";
import { DialogHelper } from "../core/util/dialogHelper";
import { ReportMetaDataHelper, Language } from "./reportMetaDataHelper";
import { WellKnownSigneeRole } from "./editRole";
import { Config } from "../core/config/config";
import { Dialog, DialogAction, DialogProps } from "../core/components/dialog";
import { ReportTest } from "./reportTest";
import { KeyValuePair, StringKeyDictionary } from "../commonInterfaces";
import React from "react";
import ReactDOM from "react-dom";
export default class ReportMetaData extends React.Component<ReportMetaDataProps, any> {
    common = new AppHelper();
    translations = {};
    disableEntityType: boolean;
    readOnly: boolean;
    signaturesFilled: boolean;
    targetEntitySelected: boolean;
    private sheet: Sheet;
    private languages: Language[];
    constructor(props: ReportMetaDataProps) {
        super(props);
        this.signaturesFilled = this.props.entity.Signatures.length > 0;
        this.disableEntityType = props.context.disableEntityType;
        this.readOnly = props.context.readOnly;
        this.common.enableHooks = false;
        this.common.init(this);
        this.props.context.translations = this.translations;
        this.sheet = General.Sheet.Manager.getTopMostSheet();
        this.targetEntitySelected = (Helper.hasValue(props.entity.TargetEntityType) && (typeof props.entity.TargetEntityType !== "string"));
        this.initApp();
    }

    private initApp = () => {
        this.checkPaths();
        ReportMetaDataHelper.getLanguages().then((langs) => {
            this.languages = langs;
        });
        if (!this.props.context.disableEntityType) {
            if (Helper.hasValue(this.props.context.sourceId)) {
                General.Functions.HistoryState.replaceState("ReportMetaData/Clone?id=" + this.props.context.sourceId);
            } else if (this.props.entity.IsNew) {
                General.Functions.HistoryState.replaceState("ReportMetaData/New");
            } else {
                General.Functions.HistoryState.replaceState("ReportMetaData/Edit?id=" + this.props.entity.Id);
            }
        }
    }

    private checkPaths = async () => {
        let result = await HTTPService.get<JsonResultClass<boolean>>("ReportMetaData/CheckPaths");
        if (!result.Data) {
            const path = Config.baseUrl + "GeneralSettings/Edit";
            let html: string = this.translations["WebSMS.ReportMetadata.PathsNotConfigured"];
            html = html.replace("<a>", `<a target="_blank" href="${path}">`);
            const targetElement = $("<div>");
            $("body").append(targetElement);
            const dialogProps: DialogProps = {
                title: this.translations["WebSMS.ReportMetadata.ErrorPaths"],
                actions: [
                    {
                        label: Config.translations.ok,
                        action: () => {
                        },
                        primary: true
                    }
                ],
                width: 500,
                afterClose: () => {
                    ReactDOM.unmountComponentAtNode(targetElement[0]);
                    targetElement[0].remove();
                }
            };
            ReactDOM.render(
                <Dialog {...dialogProps} open={true} >
                    <div dangerouslySetInnerHTML={{ __html: html }}>
                    </div>
                </Dialog >, targetElement[0]
            );
        }
    }

    private validate = async  (validateForRelease: boolean, onSave: boolean = false) => {
        if (this.common.validate()) {
            if (!ReportMetaDataHelper.dictionaryContainsAtLeastEntry(this.props.entity.Name)) {
                NotificationHelper.showWarningMessage(this.translations["WebSMS.ReportMetadata.NameIsMissing"])
                return false;
            }
            if (!ReportMetaDataHelper.dictionaryContainsAtLeastEntry(this.props.entity.ReportFiles)) {
                NotificationHelper.showWarningMessage(this.translations["WebSMS.ReportMetadata.FileIsMissing"])
                return false;;
            }
            const con = !await this.checkQrPaths()
            if (con) {
                return false;
            }


            if (validateForRelease) {
                return await this.validateForRelease(onSave)
            } else {
                return true;
            }
        } else {
            return false;
        }

    }

    private checkQrPaths = () => {
        return new Promise<boolean>(async (resolve) => {
            const result = await HTTPService.post<JsonResultClass<string[]>>("ReportMetaData/CheckQrPaths", { reportDefinition: this.props.entity });
            if (result.Code == 0) {
                if (result.Data.length > 0) {
                    const languages = result.Data.map((code) => {
                        const l = this.languages.find(f => f.Code == code);
                        return (
                            <li key={kendo.guid()}>
                                {Helper.hasValue(l) ? l.Displaynameen : code}
                            </li>
                        ); 
                            
                        
                    })
                    const targetElement = $("<div>");
                    $("body").append(targetElement);
                    const dialogProps: DialogProps = {
                        title: Helper.getTranslation("WebCRM.Email.Problems"),
                        actions: [
                            {
                                label: Config.translations.ok,
                                primary: true,
                                action: () => {
                                    resolve(false)
                                }
                            }
                        ],
                        width: 500,
                        afterClose: () => {
                            ReactDOM.unmountComponentAtNode(targetElement[0]);
                            targetElement[0].remove();
                        }
                    };
                    ReactDOM.render(
                        <Dialog {...dialogProps} open={true}>
                            <div>
                                <label>
                                    {this.translations["WebSMS.ReportMetadata.CheckFiles"]}
                                </label>
                                <ul style={{listStyle: "disc", marginLeft: "20px"}}>
                                    {languages}
                                </ul>
                            </div>
                        </Dialog >, targetElement[0]
                    );
                } else {
                    resolve(true);
                }
            } else {
                NotificationHelper.showErrorMessage(result.Message);
                resolve(false);
            }
        })
    }

    private validateForRelease = async (onSave: boolean): Promise<boolean> => {
        return new Promise<boolean>(async (resolve) => {
            const languageConsistency = ReportMetaDataHelper.checkForLanguageConsistency(this.props.entity);
            const results = await Promise.all([languageConsistency]);
            if (Helper.hasValue(results[0])) {
                const data: ValidationResult = {
                    languageConsistency: {
                        files: Helper.hasValue(results[0]) ? Helper.getValueOrDefault(results[0].files, []) : [],
                        names: Helper.hasValue(results[0]) ? Helper.getValueOrDefault(results[0].names, []) : [],
                        signatures: Helper.hasValue(results[0]) ? Helper.getValueOrDefault(results[0].signatures, []) : []
                    },
                    params: {},
                    possibleParams: this.props.context.qrParameters[ReportMetaDataHelper.getTargetEntityTypeName(this.props.entity.TargetEntityType)].sort()
                }
                const isOk = await openValidationDialog(data, this.translations, this.languages, onSave);
                resolve(isOk);
            } else {
                resolve(true);
            }
        });
    }

    validateAndSave = async (callBack: (success: boolean) => void = null) => {
        let saveAndRelease = false;
        if (!Helper.isNullOrEmpty(this.props.context.templateId)) {
            saveAndRelease ||= await DialogHelper.confirm(this.translations["WebSMS.ReportMetadata.WantToRelease"]);
        }

        if (saveAndRelease) {
            this.saveAndRelease()
        } else {
            const isValid = await this.validate(!this.props.entity.IsDraft, true);
            if (isValid) {
                this.save(callBack);
            } else if (Helper.hasValue(callBack)) {
                callBack(false);
            }
        }
    }

    private save = async (callBack: (success: boolean) => void = null) => {
        const result = await HTTPService.post<JsonResultClass<ReportDefinition>>("ReportMetaData/Save", this.props.entity);
        switch (result.Code) {
            case 0:
                if ((!this.disableEntityType) && (this.props.entity.IsNew)) {
                    General.Functions.HistoryState.replaceState("ReportMetaData/Edit?id=" + result.Data.Id);
                }
                NotificationHelper.showSuccessMessage(result.Message);
                if (Helper.hasValue(result.Data.Signatures)) {
                    this.signaturesFilled = result.Data.Signatures.length > 0;
                } else {
                    this.signaturesFilled = false;
                }
                Helper.updateEntity(this.props.entity, result.Data);
                break;
            case 1:
                NotificationHelper.showErrorMessage(result.Message)
                break;
        }
        this.common.handlePostSave(result.Code === 0, !Helper.isNullOrEmpty(this.props.context.templateId));
        if (Helper.hasValue(callBack)) {
            callBack(result.Code === 0);
        }
        this.setState({});
    }

    disable = () => {
        this.switchActive("inactive");
    }

    enable = () => {
        this.switchActive("active");
    }

    private switchActive = async (mode: "active" | "inactive") => {
        let url: string = "ReportMetaData/Disable?id=" + this.props.entity.Id
        let value: number = 0;
        let message: string = this.translations["WebSMS.ReportMetadata.AreYouSure"];
        if (mode === "active") {
            url = "ReportMetaData/Enable?id=" + this.props.entity.Id;
            value = 1;
            message = this.translations["WebSMS.ReportMetadata.AreYouSureEnable"];
        }
        const isOk = await DialogHelper.confirm(message);
        if (isOk) {
            let result = await HTTPService.get<JsonResultClass>(url);
            switch (result.Code) {
                case 0:
                    let entity = this.props.entity;
                    entity.State = value;
                    entity.IsDraft = false;
                    entity.RecordRight = {
                        CanRead: true,
                        CanWrite: false
                    };
                    Helper.updateEntity(this.props.entity, entity);
                    break;
                case 1:
                    NotificationHelper.showErrorMessage(result.Message);
                    break;
            }
            this.setState({});
        }
    }

    saveAndRelease = async () => {
        const isValid = await this.validate(true, true);
        if (isValid) {
            let entity = this.props.entity;
            entity.State = 1;
            entity.IsDraft = false;
            entity.RecordRight = {
                CanRead: true,
                CanWrite: false
            };
            Helper.updateEntity(this.props.entity, entity);
            this.setState({}, this.save);
        }
        return isValid;
    }

    clone = () => {
        const ask = (): Promise<boolean> => {
            return new Promise<boolean>((resolve) => {
                if (!this.props.entity.IsDraft && this.props.entity.State == 1) {
                    DialogHelper.choose(this.translations["WebSMS.ReportMetadata.DisableCurrentReportDefinition"], [
                        { label: this.translations["Server.No"], value: false, primary: false },
                        { label: this.translations["Server.Yes"], value: true, primary: true }
                    ], true).then((isOk: boolean) => {
                        if (Helper.hasValue(isOk)) {
                            if (isOk) {
                                HTTPService.get("ReportMetaData/Disable?id=" + this.props.entity.Id).then(() => {
                                    resolve(true);
                                });
                            } else {
                                resolve(true);
                            }
                        } else {
                            resolve(false)
                        }
                    });
                } else {
                    resolve(true);
                }
            });
        } 
        ask().then((isOk) => {
            if (isOk) {
                let stackCount = General.Sheet.Manager.getSheetsCount();
                let url = Config.baseUrl + "ReportMetaData/Clone?id=" + this.props.entity.Id;
                if (stackCount === 1) {
                    window.location.href = url;
                } else {
                    this.sheet.hide(() => {
                        this.sheet.trigger(SheetEventType.Custom, { cmd: "cloneReport", url: url })
                    });
                }
            }
        });
    }

    deleteDefinition = async () => {
        const isOK = await DialogHelper.confirm(this.translations["Standard.Msg.Loeschen"]);
        if (isOK) {
            const result = await HTTPService.get<JsonResultClass>(`ReportMetaData/Delete?id=${this.props.entity.Id}`);
            if (result.Code == 0) {
                const count = General.Sheet.Manager.getSheetsCount();
                if (count == 1) {
                    window.location.href = `${Config.baseUrl}ReportMetaData/SearchReport`;
                } else {
                    General.Sheet.Manager.getTopMostSheet().hide();
                }
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }            
        }
        
    }

    validateEntity = async () => {
        const isValid = await this.validate(true);
        if (isValid) {
            DialogHelper.choose(this.translations["WebSMS.ReportMetadata.NoAnomalies"], [{ label: Config.translations.ok, value: true, primary: true }], false, 500)
        }
    }

    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case "entity.TargetEntityType":
                if (typeof value !== "string" && value != this.props.entity.TargetEntityType) {
                    this.handleFieldChange({ model: "entity.AttachmentTypes" }, [value]);
                    this.handleFieldChange({ model: "entity.EmailTemplateId" }, null);
                }
                this.targetEntitySelected = (Helper.hasValue(value) && (typeof value !== "string"))
                setTimeout(() => { this.sheet.trigger(SheetEventType.Custom, { cmd: "targetEntityChanged" }) }, 0);
                break;
            case "entity.Signatures":
                let signatures = value as [];
                this.signaturesFilled = signatures.length > 0;
                if (signatures.length === 0 && this.props.entity.UseDateFormatForSignatures) {
                    this.handleFieldChange({ model: "entity.UseDateFormatForSignatures" }, false);
                }
                this.setState({})
                break;
            case "entity.SignatureDateFormat":
                let dateFormat = value as string;
                if (dateFormat.length > 50) {
                    dateFormat = dateFormat.substr(0, 50);
                    value = dateFormat;
                }
                break;
        }
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    testQuickReport = () => {
        const filesEmpty = () => {
            let result = true;
            Object.keys(this.props.entity.ReportFiles).forEach((key: string) => {
                result &&= Helper.isNullOrEmpty(this.props.entity.ReportFiles[key]);
            })
            return result;
        }
        if (Helper.isNullOrEmpty(this.props.entity.TargetEntityType.toString())) {
            DialogHelper.alert(this.translations["WebSMS.ReportMetadata.SelectTargetEntity"]);
        } else if (filesEmpty()) {
            DialogHelper.alert(this.translations["WebSMS.ReportMetadata.AddOneFile"]);
        } else {
            ReportTest.Open(this.props.entity);
        }
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} titleProps={""} />;
    }
}

export interface ReportDefinition extends Entity {
    Id: number;
    Name: {};
    ReportFiles: {};
    TargetEntityType: TargetEntityType;
    TargetCriterias: TargetCriterias;
    ApplicationCriteria: ApplicationCriteria[];
    UserCriteria: number[];
    Signatures: Signature[];
    IsDraft: boolean;
    State: number;
    UseDateFormatForSignatures: boolean;
    SignatureDateFormat: string;
    DocumentCategory: number;
    GenerateDocumentDefault: boolean;
    AttachmentTypes: TargetEntityType[];
    EmailTemplateId?: number;
    SenderEmail?: string;
    SenderName?:string;
}

export enum TargetEntityType {
    ServiceReport = 1,
    WeeklyReport = 2,
    CustomReport = 3,
    Assignment = 4,
    Machine = 5,
    Resource = 6,
    Ticket = 7,
    Address = 8,
    Material = 9,
    Project = 10,

    TravelReport = 13
}

export interface Signature {
    Role: number;
    WellKnownSigneeRole?: WellKnownSigneeRole;
    UniqueName: string;
    Properties: {};
    Reasons: {};
}

export interface ApplicationCriteria {
    ApplicationId: number;
    ExecutionEnvironmentId: number;
}

export interface TargetCriterias {
    Codes: number[],
    Templates: string[],
    Tags: string[]
}

export interface ReportMetaDataContext extends Context {
    translations?: StringKeyDictionary<string>;
    data?: {
        targetCodes?: KeyValuePair<number, string>[],
        targetTemplateIds?: KeyValuePair<string, string>[],
    }
    disableEntityType?: boolean;
    readOnly?: boolean;
    sourceId?: number;
    qrParameters?: {};
    templateId: string;
}

export interface ReportMetaDataProps extends AppBaseProps {
    entity: ReportDefinition;
    context: ReportMetaDataContext;
}

const openValidationDialog = (validationResult: ValidationResult, translations: {}, languages: Language[], onSave: boolean): Promise<boolean> => {
    return new Promise<boolean>((resolve) => {
        const ulStyle: React.CSSProperties = {
            listStyle: "disc",
            marginLeft: "20px"
        }
        const getLanguageConsistencyBody = (): { info: JSX.Element[], infoCount: number } => {
            let info: JSX.Element[] = [];
            let ic = 0;
            if ((validationResult.languageConsistency.names.length > 0) || (validationResult.languageConsistency.files.length > 0) || (validationResult.languageConsistency.signatures.length > 0)) {
                info.push(
                    <div key={kendo.guid()} style={{ marginBottom: "12px" }}>
                        <label style={{ fontSize: "16px" }}>
                            {translations["WebSMS.ReportMetadata.LanguageInconsistencydiscovered"]}
                        </label>
                    </div>
                );
                if (validationResult.languageConsistency.names.length > 0) {
                    info.push(
                        <React.Fragment key={kendo.guid()}>
                            <label style={{ fontSize: "14px" }}>
                                {translations["WebSMS.ReportMetadata.NoTranslationCreated"]}
                            </label>
                            <ul style={ulStyle}>
                                {validationResult.languageConsistency.names.map((code) => {
                                    const lang = languages.find(l => l.Code === code);
                                    if (Helper.hasValue(lang)) {
                                        return <li key={kendo.guid()}>{lang.Displaynameen + " (" + lang.Displaynamenative + ")"}</li>;
                                    } else {
                                        return null;
                                    }
                                })}
                            </ul>
                        </React.Fragment>
                    );
                    ic += 1;
                }
                if (validationResult.languageConsistency.files.length > 0) {
                    info.push(
                        <React.Fragment key={kendo.guid()}>
                            <label style={{ fontSize: "14px" }}>
                                {translations["WebSMS.ReportMetadata.LanguagesNoFile"]}
                            </label>
                            <ul style={ulStyle}>
                                {validationResult.languageConsistency.files.map((code) => {
                                    let lang = languages.find(l => l.Code === code);
                                    return <li key={kendo.guid()}>{lang.Displaynameen + " (" + lang.Displaynamenative + ")"}</li>;
                                })}
                            </ul>
                        </React.Fragment>
                    );
                    ic += 1;
                }
                if (validationResult.languageConsistency.signatures.filter(f => f.reasons.length === 0).length === 0) {
                    let text = translations["WebSMS.ReportMetadata.SignatureNotFilled"];
                    validationResult.languageConsistency.signatures.forEach((item) => {
                        info.push(
                            <React.Fragment key={kendo.guid()}>
                                <label style={{ fontSize: "14px" }}>
                                    {text.replace("{signature}", item.uniqueName)}
                                </label>
                                <ul style={ulStyle}>
                                    {item.reasons.map((code) => {
                                        let lang = languages.find(l => l.Code === code);
                                        return <li key={kendo.guid()}>{lang.Displaynameen + " (" + lang.Displaynamenative + ")"}</li>;
                                    })}
                                </ul>
                            </React.Fragment>
                        );
                        ic += 1;
                    });
                }
                //body = createBody(info, translations["WebSMS.ReportMetadata.LanguageInconsistencydiscovered"]);
            }
            return { info: info, infoCount: ic };
        }
        const getUnsupportedParametersBody = (): { info: JSX.Element[], infoCount: number } => {
            let info: JSX.Element[] = [];
            let ic = 0;
            let errorsExists = false;
            const keys = Object.keys(validationResult.params);
            if (keys.length > 0) {
                ic = 1;
                let lst: string[];
                for (let i = 0; i < keys.length; i++) {
                    lst = validationResult.params[keys[i]];
                    if (lst.length > 0) {
                        errorsExists = true;
                        info.push(
                            <React.Fragment key={kendo.guid()}>
                                <label style={{ fontSize: "14px" }}>
                                    {translations["WebSMS.ReportMetadata.FileContainsUnsupportedParams"].replace("{fileName}", ReportMetaDataHelper.getFileName(keys[i]))}
                                </label>
                                <ul style={ulStyle}>
                                    {lst.map((param) => {
                                        return <li key={kendo.guid()}>{param}</li>;
                                    })}
                                </ul>
                            </React.Fragment>
                        );
                        ic += 1;
                    }
                }
                if (errorsExists) {
                    info.unshift(<div key={kendo.guid()} style={{ marginBottom: "12px" }}>
                        <label style={{ fontSize: "16px" }}>
                            {translations["WebSMS.ReportMetadata.UnsuportedParamsOccured"]}
                        </label>
                    </div>);
                }
            }
            return { info: info, infoCount: ic };
        }
        const languageConsistencyBody = getLanguageConsistencyBody();
        const unsupportedParametersBody = getUnsupportedParametersBody();
        const getItem = (lst: JSX.Element[], index: number) => {
            if (lst.length > index) {
                return lst[index];
            } else {
                return null;
            }
        }
        const createTable = (lstLeft: JSX.Element[], lstRight: JSX.Element[]) => {
            const lenght = lstLeft.length > lstRight.length ? lstLeft.length : lstRight.length;
            let items: JSX.Element[] = [];
            for (let i = 0; i < lenght; i++) {
                if (i < (lenght - 1)) {
                    items.push(
                        <tr key={kendo.guid()}>
                            <td style={{ width: lstLeft.length == 0 ? "0" : "500px", paddingBottom: "10px" }}>{getItem(lstLeft, i)}</td>
                            <td style={{ width: lstRight.length == 0 ? "0" : "500px", paddingBottom: "10px" }}>{getItem(lstRight, i)}</td>
                        </tr>
                    );
                } else {
                    const rightItem = getItem(lstRight, i);
                    const info = lstRight.length > 0 ? (
                        <div style={{ display: "flex", flexDirection: "column", marginTop: "12px" }} key={kendo.guid()}>
                            <label style={{ fontSize: "14px" }}>{translations["WebSMS.ReportMetadata.FollowingParametersSupported"]}</label>
                            <ul key={kendo.guid()} style={ulStyle}>{validationResult.possibleParams.map((param) => {
                                return <li key={kendo.guid()}>{param}</li>;
                            })}</ul>
                        </div>
                    ) : null;
                    if (Helper.hasValue(rightItem)) {
                        items.push(
                            <tr key={kendo.guid()}>
                                <td style={{ width: lstLeft.length == 0 ? "0" : "500px", paddingBottom: "10px" }}>{getItem(lstLeft, i)}</td>
                                <td style={{ width: lstRight.length == 0 ? "0" : "500px", paddingBottom: "10px" }}>{rightItem}</td>
                            </tr>
                        );
                        items.push(
                            <tr key={kendo.guid()}>
                                <td style={{ width: lstLeft.length == 0 ? "0" : "500px", paddingBottom: "10px" }}></td>
                                <td style={{ width: lstRight.length == 0 ? "0" : "500px", paddingBottom: "10px" }}>{info}</td>
                            </tr>
                        );
                    } else {
                        items.push(
                            <tr key={kendo.guid()}>
                                <td style={{ width: lstLeft.length == 0 ? "0" : "500px", paddingBottom: "10px" }}>{getItem(lstLeft, i)}</td>
                                <td style={{ width: lstRight.length == 0 ? "0" : "500px", paddingBottom: "10px" }}>{info}</td>
                            </tr>
                        );
                    }
                }
            }
            return (
                <table>
                    <tbody>
                        <tr>
                            <td colSpan={2}>
                                <div style={{ marginBottom: "20px", textAlign: "center", display: "flex", flexDirection: "column" }}>
                                    <label style={{ fontSize: "20px" }}>{translations["WebSMS.ReportMetadata.PartiallyIncorrect"]}</label>
                                    {onSave ? (<label style={{ fontSize: "20px" }}>{translations["WebSMS.ReportMetadata.StillSave"]}</label>) : null}
                                </div>
                            </td>
                        </tr>
                        {items}
                    </tbody>
                </table>
                );
        }
        let infoCount = languageConsistencyBody.infoCount < unsupportedParametersBody.infoCount ? unsupportedParametersBody.infoCount : languageConsistencyBody.infoCount;
        if (onSave) {
            infoCount = infoCount + 1;
        }
        const setDialogPos = () => {
            let top = 290 - (infoCount * 45);
            if (top < 0) {
                top = 0;
            }
            let dialog = document.querySelector('[role="dialog"]') as HTMLElement;
            dialog.style.top = top + "px";
        }
        const createDialog = () => {
            const targetElement = $("<div>");
            $("body").append(targetElement);

            let actions: DialogAction[];
            if (onSave) {
                actions = [
                    {
                        label: Config.translations.cancel,
                        action: () => {
                            resolve(false);
                        }
                    },
                    {
                        label: translations["Server.Yes"],
                        action: () => {
                            resolve(true);
                        },
                        primary: true
                    }
                ];
            } else {
                actions = [
                    {
                        label: Config.translations.ok,
                        action: () => {
                            resolve(false);
                        },
                        primary: true
                    }
                ];
            }

            const dialogProps: DialogProps = {
                title: Helper.getTranslation("WebCRM.Email.Problems"),
                actions: actions,
                width: (languageConsistencyBody.info.length == 0 ? 0 : 500) + (unsupportedParametersBody.info.length == 0 ? 0 : 500),
                afterClose: () => {
                    ReactDOM.unmountComponentAtNode(targetElement[0]);
                    targetElement[0].remove();
                }
            };
            ReactDOM.render(
                <Dialog {...dialogProps} open={true} >
                    <div style={{ maxHeight: "600px" }}>
                        {createTable(languageConsistencyBody.info, unsupportedParametersBody.info)}
                    </div>
                </Dialog >, targetElement[0], setDialogPos
            );
        }
        createDialog();
    })
}

interface ValidationResult {
    params: {};
    possibleParams: string[];
    languageConsistency: {
        names: string[],
        files: string[],
        signatures: any[]
    }
}